import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ExitViewModule } from '../../shared/components/exit-view/exit-view.component.module';
import { SdcNavModule } from '../../shell/sdc-nav/sdc-nav.module';
import { UpgradeNg1Helpers } from './../../shared/helpers/upgrade/upgrade-ng1.helper';
import { SharedServicesModule } from './../../shared/services/shared.services.module';
import { StudentPanelsModule } from './../common-panels/student-panels.module';
import { StudentNavigatorModule } from './../navigation/student-navigator/student-navigator.module';
import { SsvSideNavPrimaryModule } from './../sidenav/ssv-side-nav-primary/ssv-side-nav-primary.module';
import { SsvSideNavSecondaryModule } from './../sidenav/ssv-side-nav-secondary/ssv-side-nav-secondary.module';
import { V3StudentContainer } from './student-container.component';

@NgModule({
  declarations: [
    V3StudentContainer,
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-snapshot-panel',
      inputs: ['student', 'isSummerSchoolStudent'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-grad-planning-panel',
      inputs: ['student', 'schoolUsers', 'school', 'isRestricted'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-current-program-panel',
      inputs: ['student', 'currentSchool'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-credits-panel',
      inputs: ['student', 'school'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-credit-gaps-panel-new',
      inputs: ['student', 'school', 'studentDiffs', 'studentGapPlans', 'studentSupports', 'isRestricted'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-regents-panel',
      inputs: ['student', 'school', 'studentSupports', 'isRestricted', 'saveStudent'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-supports-panel',
      inputs: ['student', 'studentSupports', 'isRestricted', 'currentUser'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-notes-panel',
      inputs: ['student', 'currentUser'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-full-exam-history-panel',
      inputs: ['student'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-full-transcript-history-panel',
      inputs: ['student'],
    }),
  ],
  imports: [
    CommonModule,
    SharedServicesModule,
    SsvSideNavPrimaryModule,
    SsvSideNavSecondaryModule,
    StudentNavigatorModule,
    StudentPanelsModule,
    MatButtonModule,
    SsvSideNavPrimaryModule,
    SsvSideNavSecondaryModule,
    ExitViewModule,
    SdcNavModule,
  ],
  exports: [V3StudentContainer],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class V3StudentContainerModule {}
